'use client';
import { AlertModal, ConfirmModal } from '@viewup/ui';
import { useGlobalModalStore } from 'app/_hook/useGlobalModalStore/useGlobalModalStore';
import { useEffect, useRef } from 'react';

export const GlobalModal = () => {
  const { getValue } = useGlobalModalStore();
  const confirmModalProps = getValue('confirmModalProps');
  const alertModalProps = getValue('alertModalProps');
  const containerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    containerRef.current = document.getElementById('wrapper');
  }, []);

  return (
    <>
      {alertModalProps && (
        <AlertModal
          {...alertModalProps}
          container={containerRef.current}
          isDuplication={true}
          styledComponents={{
            ...alertModalProps?.styledComponents,
            modalRoot: { css: { height: 'auto' } },
            title: { css: { textAlign: 'center' } },
          }}
        />
      )}
      {confirmModalProps && (
        <ConfirmModal
          {...confirmModalProps}
          container={containerRef.current}
          isDuplication={true}
          styledComponents={{
            ...confirmModalProps?.styledComponents,
            modalRoot: { css: { height: 'auto' } },
            title: { css: { textAlign: 'center' } },
          }}
        />
      )}
    </>
  );
};
